<template>
  <el-drawer v-model="drawer" title="用户详情" size="85%" :direction="direction" :before-close="handleClose">
    <div v-if="detail">
      <el-descriptions  :column="4" border>
        <el-descriptions-item label="用户" >
          <user-box :detail="detail"></user-box>
        </el-descriptions-item>
        <el-descriptions-item label="手机号码">
          <div style="min-width: 100px">{{detail.phone}}</div>
        </el-descriptions-item>
        <el-descriptions-item label="地区">
          <div style="min-width: 100px">
            {{(detail.province||"")+(detail.city||"")}}
          </div>
        </el-descriptions-item>
        <el-descriptions-item label="状态">{{detail.status?"禁用":"正常"}}</el-descriptions-item>
        <el-descriptions-item label="累计消费">￥{{detail.money ||0}}</el-descriptions-item>
        <el-descriptions-item label="购买订单">{{detail.orderCount || 0}}</el-descriptions-item>
        <el-descriptions-item label="最近登录时间">{{detail.lastLoginTime}}</el-descriptions-item>
        <el-descriptions-item label="注册时间">{{detail.createTime}}</el-descriptions-item>
      </el-descriptions>

      <qc-container class="mt20" :tab-list="['商城订单','租售订单','所属商户','亲友信息']" :active-index="activeIndex" @changeTab="changeTab">
        <on-line-order v-if="activeIndex==0" :user-id="detail.userId"></on-line-order>
        <order-list v-if="activeIndex==1" :shopType="1" :user-id="detail.userId"></order-list>
        <shop-user v-if="activeIndex==2"></shop-user>
        <user-relative v-if="activeIndex==3" :user-id="detail.userId"></user-relative>
      </qc-container>
    </div>
  </el-drawer>
</template>

<script>
import UserBox from "@view/components/user-box.vue";
import QcContainer from "@/components/el/layout/qc-container.vue";
import OnLineOrder from "@org/order/list.vue";
import OrderList from "@view/components/order/order-list.vue";
import ShopUser from "@view/components/shop/shop-user.vue";
import UserRelative from "@view/components/user/user-relative.vue";

export default {
  name: "user-detail",
  components: {UserRelative, ShopUser, OrderList, OnLineOrder, QcContainer, UserBox},
  data() {
    return {
      drawer:false,
      direction:"rtl",
      detail:null,
      activeIndex:0,
    }
  },
  mixins: [tableBase],
  methods: {
    openDrawer(id){
      this.findDetail(id);
      this.drawer=true;
    },
    handleClose(){
      this.drawer=false;
    },
    findDetail(id){
      this.simplePost("/api/mgr/user/expand/getDetail",{id:id},(res)=>{
        this.detail = res.data;
      });
    },
    changeTab(index){
      this.activeIndex = index;
    }
  },
  mounted() {

  }
}
</script>

<style scoped>

</style>
